import { connect } from 'react-redux';
import { phoneSelector } from './selectors';
import { changeView } from '../../../../actions/view';
import { PhoneSmsConfirmationInfo as Component } from '../../../../components/PhoneSmsConfirmationInfo';
import { EActiveView } from '../../../../types/view';
import { acceptLicence, acceptMarketingSubscription } from '../../../../actions/agreement';
export function mapStateToProps(state) {
  return {
    phone: phoneSelector(state)
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    onEditPhoneClick: function onEditPhoneClick(e) {
      e.preventDefault();
      dispatch(acceptLicence(false));
      dispatch(acceptMarketingSubscription(false));
      dispatch(changeView(EActiveView.PhoneAuth));
    }
  };
}
export var InfoContainer = connect(mapStateToProps, mapDispatchToProps)(Component);